/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:56:17
 *
 * LastModified: 2017-06-01 17:12:42
 *-------------------------------------------------------*/

import { take, call, put, fork } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* getStoreListFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: { filter }, next } = yield take('GET_STORE_LIST');
		try {
			const response = yield call(fetchApi, `Stores?filter=${JSON.stringify(filter)}`);
			if (response && !response.error) {
				yield put({ type: 'GET_STORE_LIST_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* clearStoreListFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { next } = yield take('CLEAR_STORE_LIST');
		yield put({ type: 'GET_STORE_LIST_SUCCESS', payload: {} });
		if (next && typeof next === 'function') {
			next();
		}
	}
}

export default function* storeFlow() {
	yield fork(getStoreListFlow);
	yield fork(clearStoreListFlow);
}



// WEBPACK FOOTER //
// ./routes/app/routes/stores/saga/index.js